import { useCurrentRefinements, useRange } from "react-instantsearch-hooks-web";
import CurrencyInput from "react-currency-input-field";
import { useState } from "react";

function PriceRangeMobile({ listingType }) {
  const { start, range, canRefine, refine, sendEvent } = useRange({
    attribute: listingType === "Rent" ? "monthlyRent" : "price",
    min: undefined,
    max: undefined,
  });
  // console.log(listingType);
  const [open, setOpen] = useState(false);
  const [min, setMin] = useState(undefined);
  const [max, setMax] = useState(undefined);
  const props = useCurrentRefinements();
  // console.log(props.items, props.canRefine, props.createURL)
  const itemRefs = props.items;
  // console.log(itemRefs);
  const arr = itemRefs.find((c) =>
    (c.attribute === listingType) === "Rent" ? "monthlyRent" : "price"
  );
  // console.log(arr);
  // console.log(arr);
  // console.log(listingType);
  return (
    <>
      <div className=" flex flex-row items-center space-x-2 ">
        <CurrencyInput
          id="min"
          name="input-min"
          placeholder="Enter min"
          className="w-1/2 rounded-md border  border-gray-400 px-4 py-2"
          allowDecimals={false}
          allowNegativeValue={false}
          //disableAbbreviations={}
          min={1}
          value={min >= 1 ? min : ""}
          prefix="Kshs "
          onValueChange={(value, name) => {
            setMin(parseInt(value));
            setTimeout(() => {
              console.log("filter", value);
              refine([
                Number.isFinite(min) ? min : undefined,
                Number.isFinite(max) ? max : undefined,
              ]);
            }, 1500);
          }}
        />
        <div className="flex">-</div>
        <CurrencyInput
          id="max"
          name="input-max"
          placeholder="Enter max"
          className="  w-1/2 rounded-md border  border-gray-400 px-4 py-2"
          allowDecimals={false}
          allowNegativeValue={false}
          min={1}
          value={max ? max : ""}
          prefix="Kshs "
          onValueChange={(value, name) => {
            setMax(parseInt(value));
            setTimeout(() => {
              console.log("filter", value);
              refine([
                Number.isFinite(min) ? min : undefined,
                Number.isFinite(max) ? max : undefined,
              ]);
            }, 1500);
          }}
        />
      </div>
    </>
  );
}
export default PriceRangeMobile;
